export default __webpack_public_path__ + "static/tab5Img-78e46d06a1f30e69f083ab87e7e2ca2a.png";